import { type SortingState } from '@tanstack/react-table';
import { useCallback, useState } from 'react';

export type SortDirection = 'asc' | 'desc' | 'none';

export type SortState = {
    sortedByField: string;
    direction: SortDirection;
};

export const useTableSort = (initial: SortState) => {
    const [sort, setSort] = useState<SortState>(initial);

    const sortBy = useCallback((sortedByField: string, direction: SortDirection) => {
        setSort({ sortedByField, direction });
    }, []);

    return { sort, sortBy };
};

export const toMuiSortOrder = (sort: SortState) =>
    sort.direction === 'none' ? undefined : { name: sort.sortedByField, direction: sort.direction };

export const toSortingState = (sort: SortState): SortingState =>
    sort.direction === 'none' ? [] : [{ id: sort.sortedByField, desc: sort.direction === 'desc' }];

export const toSortState = (sortingState: SortingState): SortState =>
    sortingState.length > 0
        ? {
              sortedByField: sortingState[0].id,
              direction: sortingState[0].desc ? 'desc' : 'asc',
          }
        : { sortedByField: '', direction: 'none' };
